import isNil from 'ramda/es/isNil';
import prop from 'ramda/es/prop';
import values from 'ramda/es/values';

import { ImageSharpResize } from 'types/codegen';

export const removeTrailingChars = (char = '') => {
  const removeRegex = new RegExp(`${char}$`);
  return (str = ''): string => str.replace(removeRegex, '');
};

export const ignoreLeadingSlash = removeTrailingChars('/');

type ImageProps = Pick<ImageSharpResize, 'src' | 'width'>;

export type GatsbyImageSharpQueryResult = {
  [key: string]: { childImageSharp?: { resize?: ImageProps | null | undefined } | null | undefined } | null | undefined;
};

const isValidImage = (image: ImageProps): boolean => !isNil(image.src) && !isNil(image.width);

export const buildSrcSet = (result: GatsbyImageSharpQueryResult): string =>
  values(result)
    .map(prop('childImageSharp'))
    .map(prop('resize'))
    .filter(isValidImage)
    .map((image) => `${image?.src} ${image?.width}w`)
    .join(', ');

export const getURLAnchor = (value: string): string => {
  const [, anchor] = value.split('#');
  if (!anchor) {
    return value;
  }
  return `#${anchor}`;
};

export const filtersQueryKey = (primaryKey: string | string[], ...filters: Record<string, unknown>[]): string[] => [
  ...(Array.isArray(primaryKey) ? primaryKey : [primaryKey]),
  ...filters
    .map((item) =>
      Object.entries(item)
        .filter(([, value]) => Boolean(value))
        .sort(([keyA], [keyB]) => keyA.localeCompare(keyB)) // Sort to prevent new cache keys due to different ordering
        .map(([key, value]) => `${key}=${value ?? ''}`)
    )
    .flat(),
];
